var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.371,
    height: 133.157,
    viewBox: "0 0 110.371 133.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "address-book-svgrepo-com",
    transform: "translate(-30.396 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6926",
    "data-name": "Path 6926",
    d: "M157.636,132.157H59.658a2.279,2.279,0,0,1-2.279-2.279V2.279A2.279,2.279,0,0,1,59.658,0h97.978a2.279,2.279,0,0,1,2.279,2.279v127.6A2.279,2.279,0,0,1,157.636,132.157Z",
    transform: "translate(-19.647)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883",
    transform: "translate(30.896 6.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6928",
    "data-name": "Path 6928",
    d: "M42.289,75.177H33.175a2.279,2.279,0,0,1,0-4.557h9.114a2.279,2.279,0,0,1,0,4.557Z",
    transform: "translate(-30.896 -59.227)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6929",
    "data-name": "Path 6929",
    d: "M42.289,31.039H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -26.482)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6930",
    "data-name": "Path 6930",
    d: "M42.289,472.418H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -353.933)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6931",
    "data-name": "Path 6931",
    d: "M42.289,119.315H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,0,1,0,4.557Z",
    transform: "translate(-30.896 -91.972)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6932",
    "data-name": "Path 6932",
    d: "M42.289,163.453H33.175a2.279,2.279,0,0,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -124.717)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6933",
    "data-name": "Path 6933",
    d: "M42.289,207.591H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -157.463)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6934",
    "data-name": "Path 6934",
    d: "M42.289,251.729H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -190.208)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6935",
    "data-name": "Path 6935",
    d: "M42.289,295.867H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -222.953)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6936",
    "data-name": "Path 6936",
    d: "M42.289,340H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -255.697)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6937",
    "data-name": "Path 6937",
    d: "M42.289,384.142H33.175a2.279,2.279,0,0,1,0-4.557h9.114a2.279,2.279,0,0,1,0,4.557Z",
    transform: "translate(-30.896 -288.443)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6938",
    "data-name": "Path 6938",
    d: "M42.289,428.28H33.175a2.279,2.279,0,1,1,0-4.557h9.114a2.279,2.279,0,1,1,0,4.557Z",
    transform: "translate(-30.896 -321.188)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6939",
    "data-name": "Path 6939",
    d: "M103.8,140.7h0a2.279,2.279,0,0,1-2.279-2.279V19.934a2.279,2.279,0,0,1,2.279-2.279h0a2.279,2.279,0,0,1,2.279,2.279V138.419A2.279,2.279,0,0,1,103.8,140.7Z",
    transform: "translate(-52.392 -13.098)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    d: "M215.144,136.971a9.114,9.114,0,0,1,9.114,9.114v1.72a45.593,45.593,0,0,1-.314,5.247,2.625,2.625,0,0,1,1.774,3.141l-1.132,4.528a1.735,1.735,0,0,1-1.683,1.314h-.069l-.442,3.534a6.8,6.8,0,0,1-2.691,4.573v2.986a3.418,3.418,0,0,0,2.479,3.286l10.166,2.9a4.557,4.557,0,0,1,3.3,4.382v5.677a2.279,2.279,0,0,1-2.279,2.279H187.8a2.279,2.279,0,0,1-2.279-2.279V183.7a4.557,4.557,0,0,1,3.3-4.382l10.166-2.9a3.418,3.418,0,0,0,2.479-3.286v-2.986a6.8,6.8,0,0,1-2.691-4.573l-.441-3.534h-.07a1.735,1.735,0,0,1-1.683-1.314l-1.132-4.528a2.626,2.626,0,0,1,1.774-3.141,45.542,45.542,0,0,1-.314-5.247v-1.72a9.114,9.114,0,0,1,9.114-9.114h9.115",
    transform: "translate(-111.333 -98.235)",
    fill: "none",
    stroke: "#6F60EE",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.cdd1d2e666f90c391640fc5c210ed8bf.svg";
export { ForwardRef as ReactComponent };